import React from 'react';
import './Spinner.css';

function Spinner({ size = 20, color = '#666' }) {
    return (
        <div className="spinner" style={{ 
            width: size, 
            height: size, 
            borderColor: `${color}20`, 
            borderTopColor: color 
        }}>
        </div>
    );
}

export default Spinner;